import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateFormService } from '../../shared/services/validate-form.service';
import { AuthService } from '../../shared/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  constructor(
    private validateForm: ValidateFormService,
    private authService: AuthService,
    private router: Router
  ) {}
  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });
  get f() {
    return this.form.controls;
  }
  onSubmit() {
    if (this.form.invalid) {
      return this.validateForm.validateAllFormFields(this.form);
    }
    this.authService
      .login(this.form.value.email, this.form.value.password)
      .subscribe({
        next: (res) => {
          localStorage.setItem('currentUser', JSON.stringify(res));
          this.authService.currentUserSubject.next(res);
          this.router.navigate(['/teams']);
        },
        error: (err) => {
          console.log(err);
        },
      });
  }
}
